import { OrientationType } from 'react-native-orientation-locker';
export const VALID_FROM_ROTATIONS = [
    OrientationType['PORTRAIT'],
    OrientationType['PORTRAIT-UPSIDEDOWN'],
    OrientationType['LANDSCAPE-LEFT'],
    OrientationType['LANDSCAPE-RIGHT'],
];
export const VALID_TO_ROTATIONS = [
    OrientationType['PORTRAIT'],
    OrientationType['LANDSCAPE-LEFT'],
    OrientationType['LANDSCAPE-RIGHT'],
];
//# sourceMappingURL=Rotations.js.map